// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"19":"e8277fd1bef5f07d1723","363":"516d4780a19deea563a5","815":"4f37c72e5faafe65a0e8"}[chunkId] + ".css";
};